<script lang="ts">
    /**
     * Den här komponenten är bara en wrapper för FilhanteringFiler. Den existerar för att stödja gamla hanteringen
     * av menyval, där varje menyval måste peka mot ett komponent namn som är unikt
     */
    // TODO Ta bort vid migrering till nya tabbhanteringen

    import fileIcon from "@/assets/allman_filko.svg";

    export default {
        tabName: "Allmän filkö",
        icon: fileIcon,
        patientBound: false,
    };
</script>

<script setup lang="ts">
    import FilhanteringFiler from "@/tabs/Filhantering/FilhanteringFiler.vue";
    import { onMounted, ref, defineExpose } from "vue";

    const child = ref();

    // Hämtar tabrelaterade options från child
    onMounted(() => {
        child.value.patientBound = false;

        defineExpose({
            tabName: "Allmän filkö",
            tabId: child.value.tabId,
            closeTab: child.value.closeTab,
        });
    });
</script>

<template>
    <FilhanteringFiler ref="child" :patient-bound-files="false" />
</template>
